export default __webpack_public_path__ + "static/media/property_423.8d38e9e9.png";